import React, { createContext, useState } from 'react';
import { DateTime } from 'luxon';
import { useBreakpoint } from '@one-thd/sui-atomic-components';
import { DateRanges } from '../utils/DateRanges';
export var CommonContext = createContext({
    dateRangeOptions: {
        startDate: '',
        endDate: '',
    },
    setDateRangeOptions: function () { return null; },
    showLoadingOverlay: false,
    setShowLoadingOverlay: function () { return null; },
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    timezone: '',
});
export var CommonProvider = function (_a) {
    var children = _a.children;
    var _b = useState(DateRanges.YTD), dateRangeOptions = _b[0], setDateRangeOptions = _b[1];
    var _c = useState(false), showLoadingOverlay = _c[0], setShowLoadingOverlay = _c[1];
    var isMobile = useBreakpoint('sm').lesser;
    var isTablet = useBreakpoint('md').exact;
    var isDesktop = useBreakpoint('lg').greater;
    var timezone = DateTime.local().zone.name;
    return (React.createElement(CommonContext.Provider, { value: {
            dateRangeOptions: dateRangeOptions,
            setDateRangeOptions: setDateRangeOptions,
            showLoadingOverlay: showLoadingOverlay,
            setShowLoadingOverlay: setShowLoadingOverlay,
            isMobile: isMobile,
            isTablet: isTablet,
            isDesktop: isDesktop,
            timezone: timezone,
        } }, children));
};
export default CommonProvider;
